var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirsflag11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_9172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.5C22.5 3.30653 22.0259 2.16193 21.182 1.31802C20.3381 0.474106 19.1935 0 18 0L0 0V36H3V19.5H15V21C15 22.1935 15.4741 23.3381 16.318 24.182C17.1619 25.0259 18.3065 25.5 19.5 25.5H36V6H22.5V4.5ZM3 3H18C18.3978 3 18.7794 3.15804 19.0607 3.43934C19.342 3.72064 19.5 4.10218 19.5 4.5V16.5H3V3ZM33 9V22.5H19.5C19.1022 22.5 18.7206 22.342 18.4393 22.0607C18.158 21.7794 18 21.3978 18 21V19.5H22.5V9H33Z",
    fill: "#008bff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_9172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirsflag11);
export default __webpack_public_path__ + "static/media/firsflag-11.ba3cfb30cdc8798154f3d926280f5bda.svg";
export { ForwardRef as ReactComponent };